import moment from 'moment'
import CookieUtils from 'utils/CookieUtils'
import conf from 'conf'
import axios from 'axios'
import * as Sentry from '@sentry/browser'

export default class FBMarketing {
  static async getIP() {
    try {
      const res = await axios.get('https://api.ipify.org/?format=json')
      return res.data.ip
    } catch {
      return ''
    }
  }

  static doDataPush(data) {
    const gdprSettings = CookieUtils.getCookie('gdpr_settings').split(',')
    const hasItems = gdprSettings.filter((cookie) => cookie === 'adv')

    if (hasItems.length > 0) {
      return false
    }

    let current_timestamp = moment().unix()

    Promise.all([this.digestMessage(data.email), this.getIP()])
      .then((data) => {
        const postData = {
          data: [
            {
              event_name: 'Subscribe',
              event_time: current_timestamp,
              action_source: 'website',
              event_id: current_timestamp,
              event_source_url: window.location.pathname,
              user_data: {
                em: [data[0]],
                client_ip_address: data[1],
                client_user_agent: navigator.userAgent
              },
              custom_data: {
                content_category: 'newsletter - submit',
                content_name: window.location.pathname
              }
            }
          ]
        }

        this.sendData(postData)
      })
      .catch((e) => Sentry.captureException(e))
  }

  static async sendData(postData) {
    axios
      .post(
        `https://graph.facebook.com/v13.0/${conf.fb_pixel_id}/events?access_token=${conf.fb_access_token}`,
        postData
      )
      .catch((e) => Sentry.captureException(e))
  }

  static async digestMessage(message) {
    const msgUint8 = new TextEncoder().encode(message)
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
    return hashHex
  }
}
